module.exports = __webpack_public_path__ + "media/images/estimate-template-56f56aff7b0ea03d3735e56bd01dbbe9.png";